import { intl } from "LocaleWrapper";

export enum TableId {
	AdminFaqManuals = "adminFaqManuals",
	AgreementTypes = "agreementTypes",
	BulkPlanning = "bulkPlanning",
	Calls = "calls",
	CallContainers = "callContainers",
	Cargos = "cargos",
	Charters = "charters",
	ConnectingVessels = "connectingVessels",
	ConnectingVisits = "connectingVisits",
	Containers = "containers",
	ContainerTypes = "containerTypes",
	Contracts = "contracts",
	ContractCharters = "contractCharters",
	ContractChildren = "contractChildren",
	ControlTowerList = "controlTowerList",
	CoreLogs = "corelogs",
	CostTypes = "costTypes",
	SalesDeclarations = "salesDeclarations",
	PurchaseDeclarations = "purchaseDeclarations",
	DeclarationNonPurchaseShips = "declarationNonPurchaseShips",
	DeclarationPurchaseCharters = "declarationPurchaseCharters",
	DeclarationSelectableSalesCharters = "declarationSelectableSalesCharters",
	DeclarationCharterCargos = "declarationCharterCargos",
	DeclarationSalesCharters = "declarationSalesCharters",
	DeclarationInvoiceLines = "declarationInvoiceLines",
	DefaultTableSettings = "defaultTableSettings",
	DeliveryConditions = "deliveryConditions",
	Fleets = "fleets",
	GasoilPrices = "gasoilPrices",
	GeofenceLogs = "geofenceLogs",
	Inactivities = "inactivities",
	Invoices = "invoices",
	InvoiceLines = "InvoiceLines",
	SalesInvoiceLines = "salesInvoiceLines",
	PurchaseInvoiceLines = "purchaseInvoiceLines",
	InvoiceGroupTypes = "invoiceGroupTypes",
	InvoiceDeclarations = "invoiceDeclarations",
	Labels = "labels",
	LocationPlanningPlannedCargos = "locationPlanningPlannedCargos",
	LocationPlanningUnplannedCargos = "locationPlanningUnplannedCargos",
	Locations = "locations",
	Nominations = "nominations",
	Notifications = "notifications",
	PaymentTerms = "paymentTerms",
	PreviousCargoes = "previousCargoes",
	ProductCategories = "productCategories",
	Products = "products",
	ProductsAdn = "productsAdn",
	ProductsIdf = "productsIdtf",
	ProductsNstr = "productsNstr",
	ProductsSupplier = "productsSupplier",
	PushedBargeVoyages = "pushedBargeVoyages",
	PurchaseCharterVoyages = "purchaseCharterVoyages",
	QuayAvailabilities = "quayAvailabilities",
	Recharge = "recharge",
	SailingSchedules = "sailingSchedules",
	SailingReports = "sailingReports",
	SalesCharters = "salesCharters",
	Ships = "ships",
	SpotSalesCharters = "spotSalesCharters",
	Staffels = "staffels",
	TemplateAgreements = "templateAgreements",
	TemplateCargos = "templateCargos",
	TemplateDefault = "templateDefault",
	TermsAndConditions = "termsAndConditions",
	Users = "users",
	VatCodes = "vatCodes",
	Voyages = "voyages"
}

export const tableDescriptions: Record<TableId, string> = {
	[TableId.AdminFaqManuals]: intl.formatMessage({ id: "ADMIN_FAQ_PDF_TITLE" }),
	[TableId.AgreementTypes]: intl.formatMessage({ id: "AGREEMENT_TYPES" }),
	[TableId.BulkPlanning]: intl.formatMessage({ id: "BOARD" }),
	[TableId.Calls]: intl.formatMessage({ id: "CALLS" }),
	[TableId.CallContainers]: `${intl.formatMessage({ id: "CALL" })} - ${intl.formatMessage({ id: "CONTAINERS" })}`,
	[TableId.Cargos]: intl.formatMessage({ id: "CARGOS" }),
	[TableId.ConnectingVessels]: intl.formatMessage({ id: "CONNECTING_VESSELS" }),
	[TableId.ConnectingVisits]: intl.formatMessage({ id: "CONNECTING_VISITS" }),
	[TableId.Charters]: intl.formatMessage({ id: "CHARTER_ORDERS" }),
	[TableId.Containers]: intl.formatMessage({ id: "CONTAINERS" }),
	[TableId.ContainerTypes]: intl.formatMessage({ id: "CONTAINER_TYPES" }),
	[TableId.Contracts]: intl.formatMessage({ id: "CONTRACTS" }),
	[TableId.ContractCharters]: `${intl.formatMessage({ id: "CONTRACT" })} - ${intl.formatMessage({ id: "CHARTERS" })}`,
	[TableId.ContractChildren]: intl.formatMessage({ id: "CHILDREN_CONTRACTS" }),
	[TableId.ControlTowerList]: intl.formatMessage({ id: "LIST" }),
	[TableId.CoreLogs]: intl.formatMessage({ id: "CORE_LOGS" }),
	[TableId.CostTypes]: intl.formatMessage({ id: "COST_TYPES" }),
	[TableId.SalesDeclarations]: intl.formatMessage({ id: "ADMINISTRATION_SALE_DECLARATIONS" }),
	[TableId.PurchaseDeclarations]: intl.formatMessage({ id: "PURCHASE_DECLARATIONS" }),
	[TableId.DeclarationNonPurchaseShips]: `${intl.formatMessage({ id: "DECLARATION" })} - ${intl.formatMessage({ id: "SHIPS" })}`,
	[TableId.DeclarationPurchaseCharters]: `${intl.formatMessage({ id: "DECLARATION" })} - ${intl.formatMessage({ id: "PURCHASE_CHARTERS" })}`,
	[TableId.DeclarationSelectableSalesCharters]: `${intl.formatMessage({ id: "DECLARATION" })} - ${intl.formatMessage({ id: "SELECT_SALES_CHARTER" })}`,
	[TableId.DeclarationCharterCargos]: `${intl.formatMessage({ id: "DECLARATION" })} - ${intl.formatMessage({ id: "CARGOS" })}`,
	[TableId.DeclarationSalesCharters]: `${intl.formatMessage({ id: "DECLARATION" })} - ${intl.formatMessage({ id: "SALES_CHARTERS" })}`,
	[TableId.DeclarationInvoiceLines]: `${intl.formatMessage({ id: "DECLARATION" })} - ${intl.formatMessage({ id: "INVOICE_LINES" })}`,
	[TableId.DefaultTableSettings]: intl.formatMessage({ id: "DEFAULT_TABLE_SETTINGS" }),
	[TableId.DeliveryConditions]: intl.formatMessage({ id: "DELIVERY_CONDITIONS" }),
	[TableId.Fleets]: intl.formatMessage({ id: "FLEETS" }),
	[TableId.GasoilPrices]: intl.formatMessage({ id: "GASOIL_PRICES" }),
	[TableId.GeofenceLogs]: intl.formatMessage({ id: "SHIP_LOG" }),
	[TableId.Inactivities]: intl.formatMessage({ id: "INACTIVITIES" }),
	[TableId.Invoices]: intl.formatMessage({ id: "INVOICES" }),
	[TableId.InvoiceLines]: intl.formatMessage({ id: "INVOICE_LINES" }),
	[TableId.SalesInvoiceLines]: intl.formatMessage({ id: "SALES_INVOICE_LINES" }),
	[TableId.PurchaseInvoiceLines]: intl.formatMessage({ id: "PURCHASE_INVOICE_LINES" }),
	[TableId.InvoiceGroupTypes]: intl.formatMessage({ id: "INVOICE_GROUP_TYPES" }),
	[TableId.InvoiceDeclarations]: `${intl.formatMessage({ id: "INVOICE" })} - ${intl.formatMessage({ id: "DECLARATIONS" })}`,
	[TableId.Labels]: intl.formatMessage({ id: "LABELS" }),
	[TableId.LocationPlanningPlannedCargos]: `${intl.formatMessage({ id: "LOCATION_PLANNING" })} - ${intl.formatMessage({ id: "PLANNED_CARGOS" })}`,
	[TableId.LocationPlanningUnplannedCargos]: `${intl.formatMessage({ id: "LOCATION_PLANNING" })} - ${intl.formatMessage({ id: "UNPLANNED_CARGOS" })}`,
	[TableId.Locations]: intl.formatMessage({ id: "LOCATIONS" }),
	[TableId.Nominations]: intl.formatMessage({ id: "NOMINATIONS" }),
	[TableId.Notifications]: intl.formatMessage({ id: "NOTIFICATIONS" }),
	[TableId.PaymentTerms]: intl.formatMessage({ id: "PAYMENT_TERMS" }),
	[TableId.PreviousCargoes]: intl.formatMessage({ id: "PREVIOUS_CARGOS" }),
	[TableId.ProductCategories]: intl.formatMessage({ id: "PRODUCT_CATEGORIES" }),
	[TableId.Products]: intl.formatMessage({ id: "PRODUCTS" }),
	[TableId.ProductsAdn]: intl.formatMessage({ id: "PRODUCT_ADN" }),
	[TableId.ProductsIdf]: intl.formatMessage({ id: "PRODUCT_IDTF" }),
	[TableId.ProductsNstr]: intl.formatMessage({ id: "PRODUCT_NSTR" }),
	[TableId.ProductsSupplier]: `${intl.formatMessage({ id: "PRODUCTS" })} - ${intl.formatMessage({ id: "SUPPLIER" })}`,
	[TableId.PushedBargeVoyages]: intl.formatMessage({ id: "PUSHED_BARGE_VOYAGES" }),
	[TableId.PurchaseCharterVoyages]: `${intl.formatMessage({ id: "PURCHASE_CHARTER" })} - ${intl.formatMessage({ id: "VOYAGES" })}`,
	[TableId.QuayAvailabilities]: intl.formatMessage({ id: "QUAY_AVAILABILITY" }),
	[TableId.Recharge]: intl.formatMessage({ id: "RECHARGE" }),
	[TableId.SailingSchedules]: intl.formatMessage({ id: "SAILING_SCHEDULES" }),
	[TableId.SailingReports]: intl.formatMessage({ id: "SAILING_REPORTS" }),
	[TableId.SalesCharters]: intl.formatMessage({ id: "SALES_CHARTERS" }),
	[TableId.Ships]: intl.formatMessage({ id: "SHIPS" }),
	[TableId.SpotSalesCharters]: intl.formatMessage({ id: "SPOT_SALES_CHARTERS" }),
	[TableId.Staffels]: intl.formatMessage({ id: "STAFFELS" }),
	[TableId.TemplateAgreements]: `${intl.formatMessage({ id: "TEMPLATE" })} - ${intl.formatMessage({ id: "AGREEMENTS" })}`,
	[TableId.TemplateCargos]: `${intl.formatMessage({ id: "TEMPLATE" })} - ${intl.formatMessage({ id: "CARGOS" })}`,
	[TableId.TemplateDefault]: `${intl.formatMessage({ id: "TEMPLATE" })} - ${intl.formatMessage({ id: "DEFAULT" })}`,
	[TableId.TermsAndConditions]: intl.formatMessage({ id: "TERMS_AND_CONDITIONS" }),
	[TableId.Users]: intl.formatMessage({ id: "USERS_TITLE" }),
	[TableId.VatCodes]: intl.formatMessage({ id: "VAT_CODES" }),
	[TableId.Voyages]: intl.formatMessage({ id: "VOYAGES" }),
};
